module.exports = __webpack_public_path__ + "static/media/Risk-Radiation.edcf6c14.png";